export default function(num: number, truncate: boolean = true): string {
  let number = num;
  let formattedNumber;

  if (num && typeof num === 'number') {
    if(truncate) {
      if (number >= 1e9) {
        formattedNumber = (number / 1e9);
        return formattedNumber % 1 === 0 ? formattedNumber.toFixed(0) + 'b' : formattedNumber.toFixed(1) + 'b';
      } else if (number >= 1e6) {
        formattedNumber = (number / 1e6);
        return formattedNumber % 1 === 0 ? formattedNumber.toFixed(0) + 'm' : formattedNumber.toFixed(1) + 'm';
      } else if (number >= 1e3) {
        return (number / 1e3).toFixed(0) + 'k';
      }
    }
    return number.toLocaleString('en-US');
  } else {
    return '0'
  }
}
